import apiUrls from '~/apiUrls.config.js';
import IBiuraRouteInfo from '~/components/biura/types/IBiuraRouteInfo';
import IBiuraWyszukajResult from '~/components/biura/types/IBiuraWyszukajResult';
import IBiuroBaseInfo from '~/components/biura/types/IBiuroBaseInfo';
import IBiuroListItem from '~/components/biura/types/IBiuroListItem';
import IDropdownItem from '~/components/biura/types/IDropdownItem';
import IPobierzBiuraParams from '~/components/biura/types/IPobierzBiuraParams';
import IWyszukajBiuraFiltry from '~/components/biura/types/IWyszukajBiuraFiltry';
import IWyszukajBiuraParams from '~/components/biura/types/IWyszukajBiuraParams';
import IWyszukajBiuraQueryParams from '~/components/biura/types/IWyszukajBiuraQueryParams';

export const defaultWojewodztwo: IDropdownItem = { Nazwa: 'Wybierz województwo', Wartosc: null };
export const defaultMiasto: IDropdownItem = { Nazwa: 'Wybierz miasto', Wartosc: null };
export const defaultLimit = 5;
export const limitShift: number = 5;

const parseQueryParamsWyszukaj = (queryParams: IWyszukajBiuraQueryParams): string => {
  const {
    wojewodztwo, miasto, czy7DniWTygodniu, czyFirmowe, szerokoscGeo, dlugoscGeo,
  } = queryParams;

  return `?wojewodztwo=${wojewodztwo || ''}&miasto=${miasto || ''}&czy7DniWTygodniu=${czy7DniWTygodniu || ''}&czyFirmowe=${
    czyFirmowe || ''
  }&szerokoscGeo=${szerokoscGeo || ''}&dlugoscGeo=${dlugoscGeo || ''}`;
};

const parseQueryParamsPobierz = (biura: number[]): string => {
  if (!biura || !biura.length) return '';

  const arr: string[] = biura.map((x, index) => `${index === 0 ? '?' : '&'}biura=${x}`);

  return arr.join('');
};

export const wyszukaj = async (params: IWyszukajBiuraParams): Promise<IBiuraWyszukajResult> => {
  const { queryParams, $http } = params;

  const url: string = `${apiUrls.biuraWyszukaj}${parseQueryParamsWyszukaj(queryParams)}`;

  const result: IBiuraWyszukajResult = await $http.$get<IBiuraWyszukajResult>(url);

  return result;
};

interface IGetBiuraDoPobraniaIdsParams {
  koordynaty: IBiuroBaseInfo[];
  listing: IBiuroListItem[];
  reset: boolean;
}

export const getBiuraDoPobraniaIds = (params: IGetBiuraDoPobraniaIdsParams): number[] => {
  const { koordynaty, listing } = params;

  if (!koordynaty || !koordynaty.length) return [];

  const ids: number[] = [];

  koordynaty.forEach((x) => {
    const shouldBreakLoop: boolean = ids.length >= limitShift;

    if (shouldBreakLoop) return;

    const shouldPush = !listing.find((y) => y.BiuroId === x.BiuroId);

    if (shouldPush) ids.push(x.BiuroId);
  });

  return ids;
};

export const pobierz = async (params: IPobierzBiuraParams): Promise<IBiuroListItem[]> => {
  const {
    $http, listing, koordynaty, listingWithLimit, reset,
  } = params;

  if (!reset && listing.length > listingWithLimit.length) return [];

  const ids: number[] = getBiuraDoPobraniaIds({ listing, koordynaty, reset });

  if (!ids || !ids.length) return [];

  const result = await $http.$get<IBiuroListItem[]>(`${apiUrls.biuraPobierz}${parseQueryParamsPobierz(ids)}`);

  return result;
};

export const initWyszukajFiltry = (): IWyszukajBiuraFiltry => ({
  wojewodztwo: defaultWojewodztwo,
  miasto: defaultMiasto,
  czy7DniWTygodniu: false,
  czyFirmowe: false,
  szerokoscGeo: null,
  dlugoscGeo: null,
});

export const getBiuraNaMape = (biura: IBiuroBaseInfo[]): IBiuroBaseInfo[] => (biura && biura.length
  ? biura.filter((x) => x.DlugoscGeo !== null && x.DlugoscGeo !== undefined && x.SzerokoscGeo !== null && x.SzerokoscGeo !== undefined)
  : []);

export const getWojewodztwa = (wojewodztwa: IDropdownItem[]): IDropdownItem[] => [defaultWojewodztwo].concat(wojewodztwa);
export const getMiasta = (miasta: IDropdownItem[]): IDropdownItem[] => [defaultMiasto].concat(miasta);
export const getWyszukajBiuraQueryParams = (filtry: IWyszukajBiuraFiltry): IWyszukajBiuraQueryParams => {
  const {
    wojewodztwo, miasto, czy7DniWTygodniu, czyFirmowe, szerokoscGeo, dlugoscGeo,
  } = filtry;

  return {
    wojewodztwo: wojewodztwo.Wartosc,
    miasto: miasto.Wartosc,
    czy7DniWTygodniu,
    czyFirmowe,
    szerokoscGeo,
    dlugoscGeo,
  };
};

interface ICalcLimitParams {
  multiplier: number;
  currentLimit: number;
}

export const calcLimit = (params: ICalcLimitParams): number => {
  const { multiplier, currentLimit } = params;

  return currentLimit + multiplier * limitShift;
};

export const checkShouldFillListingOnInit = (routeInfo: IBiuraRouteInfo) => routeInfo.DodatkowePola?.miastoUrl;
